import * as React from 'react';
import { EditCompanyItem } from './EditCompanyItem';
import { EditPersonItem } from './EditPersonItem';
import { OwnerSummary } from './OwnerSummary';
import type { Owner } from './';

interface Props {
  owner: Owner;
  singleOwner: boolean;
  undistributedCapital: number;
  onDelete: (id: string) => void;
  onOwnershipPercentageChange: (percentage: number) => void;
  onEquityChange: (equity: string) => void;
  percentOffset?: number;
}

interface State {
  editing: boolean;
}

export class OwnerItem extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { editing: false };
  }

  onToggleEdit = () => {
    this.setState({ editing: !this.state.editing });
  };

  renderEditor() {
    return this.props.owner.kind === 'person' ? (
      <EditPersonItem onDone={this.onToggleEdit} owner={this.props.owner} />
    ) : (
      <EditCompanyItem onDone={this.onToggleEdit} owner={this.props.owner} />
    );
  }

  renderSummary() {
    const { onDelete, owner, ...props } = this.props;

    return (
      <OwnerSummary
        {...props}
        owner={owner}
        onDelete={() => onDelete(owner.item.id)}
        onEdit={this.onToggleEdit}
      />
    );
  }

  render() {
    if (this.state.editing) {
      return this.renderEditor();
    } else {
      return this.renderSummary();
    }
  }
}
